export default __webpack_public_path__ + "static/media/line-chart.ce53391b.svg";